"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFieldView = void 0;
exports.SimpleFieldView = {
    viewInline(field) {
        return field.displayValue;
    },
    viewDetail(field) {
        return null;
    },
    viewEdit(field, ctrl) {
        return exports.SimpleFieldView.viewInline(field, ctrl);
    },
};
//# sourceMappingURL=field.view.js.map